import React, { useState } from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem, TextareaField, Tag, Iconsvg, ButtonFieldIcon } from '@wk/components-react16';
import { API_URL } from '../../../config/constants';
import HttpService from "../../../config/http.service";
import GaugeChart from 'react-gauge-chart';
import { Toast } from '../../../services';
import { useDispatch } from 'react-redux';
import { showLoading, hideLoading } from "../../../store/authReducer";


const ImprovePromptScore = ({ data }: any) => {
    const { isOpenConfirmScoreQuestion, setIsOpenConfirmScoreQuestion, promptCategoryScore, setPromptCategoryScore, prompt, setPrompt, onPrevious, activeIndex } = data;
	const dispatch = useDispatch();
    /* const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setPromptCategoryScore((prevObject: any) => ({
            ...prevObject,
            category_score: {
                ...prevObject.category_score,
                [name]: {
                    ...prevObject.category_score[name],
                    partial_prompt: value,
                }
            }
        }));
    }; */

    const handleInputChange = (index: number, event: any) => {
        const newList = [...promptCategoryScore];
        const { name, value } = event.target;
        newList[index][name] = value;
        setPromptCategoryScore(newList);
    };

    const getRevisedPrompt = () => {
        const payload: any = {
            promptType: prompt.promptType?.code,
            promptInstructions: prompt.text,
            categoryScore: promptCategoryScore,
        }
        dispatch(showLoading());
        HttpService.postRequest(API_URL.REVISED_PROMPT, payload).then(
            (res: any) => {
                if (res.data) {
                    setPrompt({
                        ...prompt,
                        text: res.data.revisedPrompt,
                    });
                    setIsOpenConfirmScoreQuestion(false);
                    if (activeIndex == 1) {
                        onPrevious();
                    }
                } else {
                    Toast('There is an error occurred for getting revised prompt, please try again.', "error");
                }
                dispatch(hideLoading());
            },
            (err: any) => {
                Toast(err.message, "error");
                dispatch(hideLoading());
            }
        )
    }

    const totalScore: number = promptCategoryScore.reduce((accumulator: any, current: any) => {
        return accumulator + current.score;
    }, 0);

    return (
        <div className='custom-modal'>
            <Modal
                isOpen={isOpenConfirmScoreQuestion}
                srLabelledBy={'modal-id-improve-score'}
                srDescribedBy={'modal-id-improve-score'}
                width={'750px'}>
                <ModalHeader
                    titleId={'modal-id-improve-score'}
                    isFullscreenButtonVisible={false}
                    onUserRequest={() => setIsOpenConfirmScoreQuestion(false)}>
                    Enhance Score Answer Five Questions <small className='wk-primary-blue-shade2 wk-size-2'>(Score: {totalScore}/{promptCategoryScore.length * 5})</small>
                    <span className='pr-10' style={{ width: '80px', display: 'inline-block', float: 'right' }}>
                        <GaugeChart
                            id="gauge-chart4"
                            nrOfLevels={3}
                            colors={["red", "orange", "green"]}
                            arcWidth={0.3}
                            arcsLength={[0.3, 0.5, 0.2]}
                            percent={totalScore / (promptCategoryScore.length * 5)}
                            textColor={'black'}
                            hideText={true}
                        />
                    </span>
                </ModalHeader>
                <ModalBody descriptionId="modal-id-improve-score">
                    <div className='pt-20'>
                        {promptCategoryScore.length > 0 ? promptCategoryScore.map((item: any, index: number) => (
                            <div className='mb-20 position-relative improve-score-label' key={index}>
                                <span className='position-absolute end-0 text-right'>
                                    <Tag contrastMode="light" color="green">Score: {item.score}/5</Tag>
                                </span>
                                <div className="cg-field-header" style={{ fontSize: '0.875rem', paddingRight: '90px' }}>
                                    <label className="cg-field-label d-inline-block">{index + 1}. {item.categoryScoreTypeName}
                                        <span className='wk-weight-400 wk-text-muted ml-5'>({item.categoryScoreTypeDescription})</span>
                                    </label>
                                </div>
                                {item.rationale || item.suggestion ? <div className='custom-textarea'>
                                    <div className="wk-text-muted wk-size-2 mb-5"><span className='wk-weight-500 mr-5'>Rationale:</span> {item.rationale}</div>
                                    <div className="wk-text-muted wk-size-2"><span className='wk-weight-500 mr-5'>Suggestion:</span> {item.suggestion}
                                        <div className='mb-5 wk-weight-500'><small><cite>(You can modify your prompt by considering this suggestion.)</cite></small></div>
                                    </div>
                                </div> : null}
                                <TextareaField label="" labelFor="textarea-id-6" indicator="required" size="small">
                                    <textarea id="textarea-id-6" name="partialPrompt"
                                        placeholder='Enter your input...'
                                        onChange={(event: any) => handleInputChange(index, event)}
                                        value={item.partialPrompt}
                                    ></textarea>
                                </TextareaField>
                            </div>
                        )) : null}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField mode={'text'}>
                                <button
                                    type="button"
                                    id="cancel"
                                    onClick={() => setIsOpenConfirmScoreQuestion(false)}>
                                    Close
                                </button>
                            </ButtonField>
                                <ButtonField>
                                    <button
                                        type="button"
                                        id="defaultClose"
                                        onClick={() => getRevisedPrompt()}>
                                        Get Revised Prompt
                                    </button>
                                </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ImprovePromptScore;